const state = {
  component: null,
  content: null,
}

const mutations = {
  setComponent(state, component){
    state.component = component;
  },

  setContent(state, content){
    state.content = content;
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
